import { CanMatchFn, Route, UrlSegment } from '@angular/router';

export function isValidCobrarActionFormat(action: string): boolean {
    const normalizedAction: string = (action ?? '').toLowerCase();
    const separator: string = '-a-';
    const separatorIndex: number = normalizedAction.indexOf(separator);

    if (separatorIndex <= 0 || separatorIndex !== normalizedAction.lastIndexOf(separator)) {
        return false;
    }

    const system1: string = normalizedAction.slice(0, separatorIndex);
    const system2: string = normalizedAction.slice(separatorIndex + separator.length);

    return /^[a-z0-9_-]+$/.test(system1) && /^[a-z0-9_-]+$/.test(system2);
}

export const validCobrarActionCanMatch: CanMatchFn = (
    _route: Route,
    segments: Array<UrlSegment>,
): boolean => {
    if (segments.length !== 2) {
        return false;
    }

    return isValidCobrarActionFormat(segments[1]?.path ?? '');
};
